import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import InfoIcon from '@mui/icons-material/Info';

const TABS: TabNavItem[] = [
  { id: 'overview', label: 'Overview', icon: InfoIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
];

export const GenericEntityPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'overview' && <CoreDetailsTab />}
        {activeTab === 'relations' && <RelationsTab />}
      </>
    )}
  </EntityPageLayout>
);
